import type { NonEmptyArray } from "./utilityTypes"

export const assertIsNonEmptyArray = <T>(
  value: Array<T>
): NonEmptyArray<T> => {
  if (value.length === 0) {
    throw new Error(
      "value provided to assertIsNonEmptyArray is empty"
    )
  }

  return value as NonEmptyArray<T>
}
